exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".yu-currency-symbol{font-family:Arial;font-style:normal}", "", {"version":3,"sources":["/Users/Min/Work/Code/ThirdApps/kanjia/front/src/base/YouUI/Currency/Currency.vue"],"names":[],"mappings":"AACA,oBACE,kBAAqB,AACrB,iBAAmB,CACpB","file":"Currency.vue","sourcesContent":["\n.yu-currency-symbol {\n  font-family: 'Arial';\n  font-style: normal;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1bf81358","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/base/YouUI/Currency/Currency.vue
// module id = 230
// module chunks = 0